const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDg1LjMzMyA1MTIgMzQxLjMzMyI+CjxyZWN0IHk9Ijg1LjMzMSIgZmlsbD0iI0Q4MDAyNyIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIzNDEuMzM3Ii8+CjxyZWN0IHk9Ijg1LjMzMSIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIxMTMuNzc1Ii8+CjxyZWN0IHk9IjMxMi44ODIiIGZpbGw9IiNGRkRBNDQiIHdpZHRoPSI1MTIiIGhlaWdodD0iMTEzLjc3NSIvPgo8L3N2Zz4K";
export {
  I as default
};
//# sourceMappingURL=DE-2f69ad09.mjs.map
